import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "Explore", to: "/explore" },
  { label: "Services", to: "/services" },
  { label: "List Your Business", to: "/list-business" },
  { label: "List Your Service", to: "/list-service" },
  { label: "Claim Business", to: "/list-business" },
  { label: "Get Your Website", to: "/get-your-website" },
  { label: "Contact", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
  { label: "Disclaimer", to: "/disclaimer" },
];

export function Footer() {
  return (
    <footer className="bg-[#0f1115] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div className="max-w-sm">
          <span className="font-display text-2xl font-extrabold">Oye<span className="text-primary">Best</span></span>
          <p className="mt-3 text-white/70 leading-relaxed">Apne Shehar Ki Best Jagah, Ek Jagah.</p>
          <p className="mt-4 text-sm text-white/50">Discover the best local businesses & services in your city.</p>
        </div>

        <div>
          <h4 className="font-display font-bold mb-4 text-white/90">Quick Links</h4>
          <div className="grid grid-cols-2 gap-x-6 gap-y-2">
            {LINKS.map((l) => (
              <Link key={l.label} to={l.to} className="text-sm text-white/60 hover:text-primary transition-colors" data-testid={`footer-${l.label.toLowerCase().replace(/ /g, "-")}`}>
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold mb-4 text-white/90">Contact</h4>
          <a href="tel:8920255908" className="flex items-center gap-2 text-sm text-white/60 hover:text-primary mb-2">
            <Phone className="w-4 h-4" /> 8920255908
          </a>
          <a href="mailto:oyebest.in@gmail.com" className="flex items-center gap-2 text-sm text-white/60 hover:text-primary mb-2">
            <Mail className="w-4 h-4" /> oyebest.in@gmail.com
          </a>
          <a href="mailto:ompgroup.of@gmail.com" className="flex items-center gap-2 text-sm text-white/60 hover:text-primary">
            <Mail className="w-4 h-4" /> ompgroup.of@gmail.com
          </a>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
        © {new Date().getFullYear()} OyeBest • oyebest.in — All rights reserved.
      </div>
    </footer>
  );
}
